import DefaultActionManager from "./default_action_manager";
import { RECAPTCHA_SITE_TOKEN } from "../constants/recaptcha";

export const ADVERTISER_SIGN_UP = "ADVERTISER_SIGN_UP";

class AdvertiserSignUpActionManager extends DefaultActionManager {
  execute(dispatch, getState) {
    return new Promise((resolve, reject) => {
      return window.grecaptcha.execute(RECAPTCHA_SITE_TOKEN, { action: "sign_in" }).then(token => {
        this.args.headers = { ...this.args.headers, Recaptcha: token };
        return super
          .execute(dispatch, getState)
          .then(resolve)
          .catch(reject);
      });
    });
  }
}

export const createAdvertiserContact = contact => {
  return new AdvertiserSignUpActionManager({
    actionName: ADVERTISER_SIGN_UP,
    route: `advertiser-contacts`,
    auth: true,
    body: contact,
    method: "POST",
  }).run();
};
